
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { EmailOtpVerification } from '../EmailOtpVerification';
import { PhoneOtpVerification } from '../PhoneOtpVerification';
import { VerificationStatus } from '../VerificationStatus';
import { VerificationMethod } from '@/hooks/useVerificationMethods';

interface VerificationFormProps {
  error: string | null;
  verifiedMethods: Record<string, boolean>;
  emailMethod?: VerificationMethod;
  phoneMethod?: VerificationMethod;
  phoneLoading: boolean;
  handleVerifyPhoneOtp: (otp: string) => Promise<void>;
  resendPhoneOtp: () => void;
  handleMethodVerified: (type: 'email' | 'phone') => void;
  onCancel?: () => void;
}

export const VerificationForm = ({
  error,
  verifiedMethods,
  emailMethod,
  phoneMethod,
  phoneLoading,
  handleVerifyPhoneOtp,
  resendPhoneOtp,
  handleMethodVerified,
  onCancel
}: VerificationFormProps) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-lg font-medium">Verify Your Account</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Complete the verification steps below
        </p>
      </div>
      
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      {emailMethod && !verifiedMethods.email && (
        <EmailOtpVerification 
          email={emailMethod.value} 
          onVerified={() => handleMethodVerified('email')} 
        />
      )}
      
      {emailMethod && (
        <VerificationStatus 
          type="email" 
          verified={!!verifiedMethods.email} 
        />
      )}
      
      {phoneMethod && !verifiedMethods.phone && (
        <PhoneOtpVerification 
          verifyPhoneOtp={handleVerifyPhoneOtp}
          resendCode={resendPhoneOtp}
          loading={phoneLoading}
          onVerified={() => handleMethodVerified('phone')}
        />
      )}
      
      {phoneMethod && (
        <VerificationStatus 
          type="phone" 
          verified={!!verifiedMethods.phone} 
        />
      )}
      
      {onCancel && (
        <Button 
          variant="outline" 
          onClick={onCancel} 
          disabled={phoneLoading}
          className="w-full mt-4"
        >
          Cancel
        </Button>
      )}
    </div>
  );
};
